import gql from 'graphql-tag'

export const CALCULATION_PROJECT_QUERY = gql`
  query {
    getCalculationProject {
      projectNumber
    }
  }
`
